import { Dumbbell, Heart, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { sharedImage } from "@/lib/images";
import content from "@/data/content/about.json";

const ICONS = { Dumbbell, Heart, Sparkles };

export default function About() {
  return (
    <main data-testid="about-page" className="pt-[60px] md:pt-[72px] bg-ivory">
      {/* Story */}
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-16 pb-12">
        <Reveal>
          <span className="text-xs tracking-[0.25em] uppercase text-terracotta font-medium">
            {content.eyebrow}
          </span>
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="mt-5 font-serif text-4xl md:text-6xl font-semibold text-brown leading-[1.1]">
            {content.heading}
          </h1>
        </Reveal>
        <Reveal delay={0.14}>
          <div className="mt-8 space-y-5 text-brown/80 text-lg leading-relaxed">
            {content.story.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
            <p className="font-serif text-2xl text-terracotta italic">
              {content.storyHighlight}
            </p>
          </div>
        </Reveal>
      </section>

      {/* Hosts */}
      <section className="bg-[#F7F2EA]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
          <Reveal>
            <h2 className="font-serif text-3xl md:text-5xl font-semibold text-brown text-center">
              {content.hostsHeading}
            </h2>
          </Reveal>

          <div className="mt-14 grid gap-8 md:grid-cols-2">
            {content.hosts.map((h, i) => (
              <Reveal key={h.name} delay={i * 0.12}>
                <div
                  data-testid={`host-card-${i}`}
                  className="bg-white rounded-2xl overflow-hidden shadow-[0_8px_30px_rgba(74,49,37,0.06)] h-full flex flex-col sm:flex-row"
                >
                  <div className="sm:w-2/5 aspect-square sm:aspect-auto overflow-hidden">
                    <img src={sharedImage(h.image)} alt={h.name} loading="lazy" className="h-full w-full object-cover" />
                  </div>
                  <div className="p-7 flex flex-col sm:w-3/5">
                    <h3 className="font-serif text-2xl font-semibold text-brown">{h.name}</h3>
                    <p className="mt-1 text-sm text-brown/60">{h.role}</p>
                    <div className="mt-4 flex flex-wrap gap-2">
                      {h.traits.map((t) => (
                        <span key={t} className="rounded-full bg-gold/15 px-3 py-1 text-xs font-medium text-brown-soft">
                          {t}
                        </span>
                      ))}
                    </div>
                    <p className="mt-4 text-brown/75 leading-relaxed flex-1">{h.note}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          {/* Values */}
          <div className="mt-16 grid gap-6 sm:grid-cols-3">
            {content.values.map((v, i) => {
              const Icon = ICONS[v.icon] || Heart;
              return (
                <Reveal key={v.title} delay={i * 0.1}>
                  <div className="text-center px-4">
                    <div className="mx-auto h-12 w-12 rounded-full bg-terracotta/10 flex items-center justify-center">
                      <Icon className="h-6 w-6 text-terracotta" />
                    </div>
                    <h4 className="mt-4 font-serif text-xl text-brown">{v.title}</h4>
                    <p className="mt-2 text-sm text-brown/70 leading-relaxed">{v.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
